import { createSlice } from '@reduxjs/toolkit'
import { DeleteShippingInfo, UpdateStateOrderInfo } from '../services/last-state-service';

const initialOrderInfoState = {
  fullName: '',
  email: '',
  shippingAddress: '',
  shippingAddressCont: '',
  zipCode: '',
  city: '',
  state: '',
  country: '',
  prefixPhoneNumber: '',
  phoneNumber: '',
  sizes: []
};

export const orderInfoSlice = createSlice({
  name: 'orderInfoAmount',
  initialState: {
    value: { ...initialOrderInfoState},
  },
  reducers: {
    setOrderInfo: (state, action) => {
      state.value = action.payload;
      UpdateStateOrderInfo(action.payload);
    },

    resetOrderInfo: (state) => {
      state.value = initialOrderInfoState;
      DeleteShippingInfo();
    },

    deleteOrderItemByIndex: (state, action) => {
      const indexToDelete = action.payload;

      const newSizes = state.value.sizes.filter((_, index) => index !== indexToDelete);

      state.value = { ...state.value, sizes: newSizes };

      UpdateStateOrderInfo(state.value);
    }
  },
})

export const { setOrderInfo, resetOrderInfo, deleteOrderItemByIndex } = orderInfoSlice.actions

export const selectOrderInfo = (state) => state.orderInfo.value

export default orderInfoSlice.reducer
